import { PerfilProfissional } from '../../../features/perfis-profissionais/perfil-profissional.model';
import { DateUtil } from '../../utils/date.util';
import { CicloFase } from './ciclo-fase.model';
import { startOfDay, endOfDay } from 'date-fns';

export class ChamadaEtapaPerfil {
  id!: number;
  cicloFase!: CicloFase;
  perfilProfissional!: PerfilProfissional;
  dtFim!: string;
  dtInicio!: string;
  hrInicio!: string;
  hrFim!: string;
  vigente!: boolean;

  constructor(partial: Partial<ChamadaEtapaPerfil>) {
    Object.assign(this, partial);
  }

  stillVigente(): boolean {
    const now = new Date();
    const dtInicio = startOfDay(
      DateUtil.fromString(this.dtInicio.toString(), 'yyyy-MM-dd'),
    );
    const dtFim = endOfDay(DateUtil.fromString(this.dtFim, 'yyyy-MM-dd'));

    const hrInicio = this.hrInicio ? this.hrInicio.split(':').map(Number) : [0, 0];
    const hrFim = this.hrFim ? this.hrFim.split(':').map(Number) : [23, 59];

    if (now < dtInicio || (now.getHours() < hrInicio[0] || (now.getHours() === hrInicio[0] && now.getMinutes() < hrInicio[1]))) {
      return false;
    }

    if (now > dtFim || (now.getHours() > hrFim[0] || (now.getHours() === hrFim[0] && now.getMinutes() > hrFim[1]))) {
      return false;
    }

    return true;
  }
}
